import { transport } from '../transport';
import { AUTHENTICATION_PATH } from './config';

function logout() {
  return transport.post(`${AUTHENTICATION_PATH}/logout`);
}

export const loginService = {
  logout,
};
